import languages from "./data/languages";

const translateText = (text, selectedLanguage) => {
  return languages[selectedLanguage][text];
};

export default translateText;
